import React from "react";
import { Box, AspectRatio, rem } from "@mantine/core";
import { DimmedText } from "./UI/Typography";

interface VideoEmbedProps {
  url: string;
  title: string;
}

/**
 * VideoEmbed - Component for embedding YouTube videos
 * Usage: <VideoEmbed url="https://youtube.com/watch?v=..." title="Video Title" />
 */
export const VideoEmbed: React.FC<VideoEmbedProps> = ({ url, title }) => {
  const getYouTubeVideoId = (url: string) => {
    const match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/);
    return match ? match[1] : null;
  };

  const videoId = getYouTubeVideoId(url);

  if (!videoId) {
    return (
      <Box style={{ textAlign: "center", padding: rem(40) }}>
        <DimmedText>Video preview not available</DimmedText>
      </Box>
    );
  }

  return (
    <AspectRatio ratio={16 / 9}>
      <iframe
        src={`https://www.youtube.com/embed/${videoId}`}
        title={title}
        style={{
          border: "none",
          borderRadius: rem(4),
          width: "100%",
          height: "100%",
        }}
        allowFullScreen
      />
    </AspectRatio>
  );
};

export default VideoEmbed;

